import { render, staticRenderFns } from "./RefurbishmentJob.vue?vue&type=template&id=00db3aab&scoped=true"
import script from "./RefurbishmentJob.vue?vue&type=script&lang=js"
export * from "./RefurbishmentJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db3aab",
  null
  
)

export default component.exports